import { privateClient } from '../axios';

export async function getClientInformation(clientId) {
  return privateClient.post('/client', {
    clientId,
  },
  {
    withCredentials: true,
  });
}
